import { Navigate } from 'react-router';
import { getDefaultLandingPath } from '@/store/prefs';

/**
 * Router index element. Reads the per-user landing pref so a teacher who
 * always opens "/attendance/daily" doesn't have to click through Dashboard
 * on every login.
 */
export function DefaultLandingRedirect() {
  return <Navigate to={getDefaultLandingPath()} replace />;
}
